<template>
    <div class="gallery-cell">
      <figure>
          <div class='responsive_video' v-html="videoHtml"></div>
          <figcaption>
            <div class="info">
              <div class="name">{{ title }}</div>
              <div class="associations video-text">
                <p>{{ description }}</p>
                <p>Duration: {{ duration }}</p>
              </div>
            </div>
          </figcaption>
      </figure>
    </div>
</template>

<script>
export default {
  props: {
    videoData: Array,
    close: Function,
    options: Array,
  },
  computed: {
    videoHtml() {
      const { code, html } = this.videoData[0].contentEmbedAsset;
      
      const iframe = code ? code : html;
      let params = '?'

      this.options.forEach(({ selected, valid, value }) => {
        if (valid && selected) {
          if (value === 'showControls') {
            params += '&controls=1';
          } else if (value === 'loop') {
            params += '&loop=1';
          } else if (value === 'mute' && !params.includes('autoplay')) {
            params += '&mute=1';
          } else if (value === 'autoPlay') {
            params += '&autoplay=1&mute=1'; /* youtube requires autoplay be muted */
          }
        }
      });

      params += '&';

      const iframeArray = iframe.split('?');
      iframeArray.splice(1, 0, params);

      return iframeArray.join('');
    },
    description() {
      return this.videoData[0].description;
    },
    duration() {
      return this.videoData[0].duration;
    },
    title() {
      return this.videoData[0].title;
    },
  },
  methods: {
    complete() {
      this.viewSuccess = true;
      this.close();
      this.$emit('completed');
    },
  }
}
</script>
